/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   xzToken and csrf Token manager
 */

import { localStorageSingleton } from '@zcode/nr-utils'

export const get = () => ({
  xzToken: localStorageSingleton.get('xzToken'),
  csrfToken: localStorageSingleton.get('csrfToken'),
})

export const set = ({ xzToken, csrfToken }) => {
  if (xzToken !== undefined) {
    localStorageSingleton.set('xzToken', xzToken)
  }
  if (csrfToken !== undefined) {
    localStorageSingleton.set('csrfToken', csrfToken)
  }
}

export const clear = () => {
  localStorageSingleton.del('xzToken')
  localStorageSingleton.del('csrfToken')
}
